import * as React from 'react';
import { useRef, useState, useEffect } from 'react';
import { Row, Col, Button, Input } from 'reactstrap';
import MultiSelectDropdown from './MultiSelectDropdown';

interface props {
  options: {
    id: string;
    label: string;
    placeholder?: string;
    number?: boolean;
    toggle?: boolean;
    values?: any[];
  }[];
  defaultValues: {
    select: string;
    input: string | number;
  };
  // I cant think of a better name
  submitable: boolean;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  onSubmit?: Function;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  onSelect?: Function;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  onDeselect?: Function;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  onChange?: Function;
  /** Notify parent when the search-field dropdown changes (after input is cleared). */
  onSearchFieldChange?: (selectId: string) => void;
}

const DDTableFilterStyles = require('./DDTable.css');

export const TableSearch = ({
  options,
  onSubmit,
  onChange,
  submitable,
  defaultValues,
  onSelect,
  onDeselect,
  onSearchFieldChange,
}: props) => {
  const [labelMap, setLabelMap] = useState<Record<string, any>>({});

  const inputRef = useRef<HTMLInputElement>(null);
  const selectRef = useRef<HTMLInputElement>(null);
  const [currentOption, setCurrentOption] = useState<any>(undefined);

  useEffect(() => {
    const newLabelMap = {};

    options.forEach((option) => {
      newLabelMap[option.id] = option.label;
    });

    setLabelMap(newLabelMap);
  }, []);

  useEffect(() => {
    if (defaultValues.select && selectRef.current) {
      selectRef.current.value = defaultValues.select;
    }
    const selectedId =
      selectRef.current?.value ||
      (options.length > 0 ? options[0].id : undefined);
    const option = options.find((o) => o.id === selectedId);
    if (option?.id !== currentOption?.id || option?.toggle !== currentOption?.toggle) {
      setCurrentOption(option);
    }
  }, [defaultValues.select, options, currentOption]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = String(defaultValues.input ?? '');
    }
  }, [defaultValues.input]);

  const parseInput = () => {
    return options.filter((option) => option.id === selectRef.current?.value)[0]
      ?.number
      ? Number(inputRef.current?.value) || ''
      : inputRef.current?.value.trim();
  };

  return (
    <div>
      <label>{labelMap[selectRef.current?.value] || ''}</label>
      <Row>
        <Col sm={4} className={DDTableFilterStyles.fitContents}>
          <Input
            onChange={(e) => {
              const selectedId = e.target.value;
              const currentOption = options.filter(
                (option) => option.id === selectedId
              )[0];
              if (inputRef.current) {
                inputRef.current.value = '';
              }
              setCurrentOption(currentOption);
              if (selectedId !== undefined && selectedId !== null) {
                onSearchFieldChange?.(String(selectedId));
              }
            }}
            innerRef={selectRef}
            type="select"
            className={DDTableFilterStyles.fitContents}
          >
            {options.map((option, index) => (
              <option key={index} value={option.id}>
                {option.label}
              </option>
            ))}
          </Input>
        </Col>

        {currentOption?.toggle && (
          <Col>
            <MultiSelectDropdown
              values={currentOption.value}
              single={true}
              defaultChecked={
                defaultValues.input && String(defaultValues.input).trim() !== ''
                  ? [
                      [
                        defaultValues.input,
                        currentOption.value?.findIndex(
                          (val: any) => val.id === defaultValues.input
                        ) ?? 0,
                      ],
                    ]
                  : []
              }
              handleDeselect={(id) => onDeselect(id, currentOption.id)}
              handleSelect={(id) => onSelect(id, currentOption.id)}
            />
          </Col>
        )}
        {submitable ? (
          <>
            <Col hidden={currentOption?.toggle}>
              <Input
                innerRef={inputRef}
                placeholder={''}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    onSubmit(
                      parseInput(),
                      selectRef.current?.value,
                      submitable
                    );
                  }
                }}
              />
            </Col>
            <Col sm={3}>
              <Button
                onClick={() => {
                  onSubmit(parseInput(), selectRef.current?.value, submitable);
                }}
                block
                disabled={
                  currentOption?.toggle &&
                  defaultValues.input !== undefined &&
                  defaultValues.input !== null &&
                  String(defaultValues.input).trim().length > 0
                }
              >
                Load Data
              </Button>
            </Col>
          </>
        ) : (
          <Col hidden={currentOption?.toggle}>
            <Input
              innerRef={inputRef}
              onChange={() =>
                onChange(parseInput(), selectRef.current?.value, submitable)
              }
              placeholder={''}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};
